export default "__VITE_ASSET__ceff2fa9__"